import { useTranslation } from "@outschool/localization";

interface AutosuggestV1PlaceholderConfig {
  /** Display name shown to the user */
  name: string;
  /** Search query value */
  value: string;
  category?: string;
}

export function useAutosuggestV1PlaceholderSuggestions(): AutosuggestV1PlaceholderConfig[] {
  const { t } = useTranslation(
    "ui-components-website\\search\\autosuggestEmptyQueryV1PlaceholderSearches",
  );

  return [
    {
      name: t("KPop Demon Hunters (yes, it’s real!)"),
      value: "KPop Demon Hunters",
      category: "Social Studies",
    },
    {
      name: t("Roblox with a princess teacher"),
      value: "Roblox with a princess teacher",
      category: "Games & Hobbies",
    },
    {
      name: t("ADHD-friendly sketchnoting"),
      value: "ADHD-friendly sketchnoting",
      category: "Health & Wellness",
    },
    {
      name: t("Dress-up & roleplay learning"),
      value: "Dress-up & roleplay learning",
      category: "Life Skills",
    },
    {
      name: t("Full homeschool curriculum options"),
      value: "Full homeschool curriculum options",
      category: "Full Curriculum",
    },
    {
      name: t("Dungeons & Dragons for newbies"),
      value: "Dungeons & Dragons for newbies",
      category: "Games & Hobbies",
    },
    {
      name: t("Video game character art"),
      value: "Video game character art",
      category: "Arts",
    },
    {
      name: t("Cantonese & Mandarin immersion for kids"),
      value: "Cantonese Mandarin immersion for kids",
      category: "Languages",
    },
    {
      name: t("Farm animals for aspiring vets"),
      value: "Farm animals for aspiring vets",
      category: "Science",
    },
    {
      name: t("Barbie imaginative play"),
      value: "Barbie imaginative play",
      category: "Games & Hobbies",
    },
    {
      name: t("Montessori homeschool programs"),
      value: "Montessori homeschool programs",
      category: "Full Curriculum",
    },
    {
      name: t("Fairy tale crafts & story time"),
      value: "Fairy tale crafts & story time",
      category: "English Language Arts",
    },
    {
      name: t("Art history: get the tea on famous artists"),
      value: "Art history get the tea on famous artists",
      category: "Arts",
    },
    {
      name: t("Vocal performance & singing"),
      value: "Vocal performance & singing",
      category: "Music",
    },
    {
      name: t("Makeup & nail art for tweens"),
      value: "Makeup nail art for tweens",
      category: "Life Skills",
    },
    {
      name: t("Theater & improv for kids"),
      value: "Theater improv for kids",
      category: "Arts",
    },
    {
      name: t("Beginner drum lessons"),
      value: "Beginner drum lessons",
      category: "Music",
    },
    {
      name: t("Debate clubs with wild topics"),
      value: "Debate clubs with wild topics",
      category: "Life Skills",
    },
    {
      name: t("Crochet for ages 8-13"),
      value: "Crochet for ages 8-13",
      category: "Arts",
    },
    {
      name: t("Interior design for creatives"),
      value: "Interior design for creatives",
      category: "Arts",
    },
    {
      name: t("Comics & graphic novel drawing"),
      value: "Comics & graphic novel drawing",
      category: "Arts",
    },
    {
      name: t("Winter break art adventures"),
      value: "Winter break art adventures",
      category: "Arts",
    },
    {
      name: t("Holiday science experiments"),
      value: "Holiday science experiments",
      category: "Science",
    },
    {
      name: t("Start 2026 with coding"),
      value: "Start 2026 with coding",
    },
    {
      name: t("Self-paced for busy schedules"),
      value: "Self-paced for busy schedules",
    },
    {
      name: t("New year writing workshops"),
      value: "New year writing workshops",
      category: "English Language Arts",
    },
    {
      name: t("Holiday baking classes"),
      value: "Holiday baking classes",
      category: "Holidays",
    },
    {
      name: t("December financial literacy for teens"),
      value: "December financial literacy for teens",
      category: "Life Skills",
    },
    {
      name: t("Winter outdoor survival skills"),
      value: "Winter outdoor survival skills",
      category: "Life Skills",
    },
    {
      name: t("Spanish immersion for little ones"),
      value: "Spanish immersion for little ones",
      category: "Languages",
    },
    {
      name: t("Phonics & learn to read"),
      value: "Phonics & learn to read",
      category: "English Language Arts",
    },
    {
      name: t("Chess for little grandmasters"),
      value: "Chess for little grandmasters",
      category: "Social Clubs",
    },
    {
      name: t("ESL conversation time"),
      value: "ESL conversation time",
      category: "Languages",
    },
    {
      name: t("Public speaking & debate"),
      value: "Public speaking & debate",
      category: "Life Skills",
    },
    {
      name: t("Piano through video games"),
      value: "Piano through video games",
      category: "Music",
    },
    {
      name: t("French with native speakers"),
      value: "French with native speakers",
      category: "Languages",
    },
    {
      name: t("Classes for shy & sensitive kids"),
      value: "Classes for shy & sensitive kids",
      category: "Health & Wellness",
    },
    {
      name: t("Make-something-real project classes"),
      value: "Make-something-real project classes",
      category: "Life Skills",
    },
    {
      name: t("Writing for reluctant writers"),
      value: "Writing for reluctant writers",
      category: "English Language Arts",
    },
    {
      name: t("Teachers who get neurodivergent learners"),
      value: "Teachers who get neurodivergent learners",
      category: "Health & Wellness",
    },
    {
      name: t("Patient teachers for anxious learners"),
      value: "Patient teachers for anxious learners",
      category: "Health & Wellness",
    },
  ];
}
